import {
  Alert,
  Box,
  Button,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Switch,
  TextField,
  Typography,
  IconButton,
  Tooltip,
  RadioGroup,
  FormLabel,
  Radio,
} from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import {
  BUTTON_STYLES,
  FORM_STYLES,
  MODAL_STYLES,
  TEXT_FIELD_STYLES,
} from "../../styles/componentStyles";
import { useFormik } from "formik";
import api from "../../axiosInstance";
import { toast } from "react-toastify";
import StatesValidationSchema from "../Validations/AcademicsValidation";
import Staets from "./States";
import DeleteIcon from "@mui/icons-material/Delete";
import UploadFileIcon from "@mui/icons-material/UploadFile";

function UniversityModal({ States, open, onClose, universityEdit, onSuccess }) {
  const [categories, setCategories] = useState([]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [states, setStates] = useState([]);
  const [universityImage, setUniversityImage] = useState(null);
  const [imageError, setImageError] = useState(null);
  console.log(universityEdit);

  // Fetch dropdown data once
  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        const statesRes = await api.get("/getAllStates");
        setStates(statesRes.data.data);
      } catch (err) {
        const message =
          err.response?.data?.message ||
          err.message ||
          "Something went wrong while fetching dropdown data";
        setError(message);
        console.error("Dropdown fetch error:", err);
      }
    };

    fetchDropdownData();
  }, []);
  console.log(universityEdit);

  //  Form vlaidation using useFormik hook
  const formik = useFormik({
    initialValues: {
      name: universityEdit?.name || "",
      code: universityEdit?.code || "",
      image: universityEdit?.image || "",
      thumbnail: universityEdit?.thumbnail || "",
      stateId: universityEdit?.stateId || "",
      active:
        universityEdit?.active !== undefined
          ? String(universityEdit.active)
          : "true",
      viewable:
        universityEdit?.viewable !== undefined
          ? String(universityEdit.viewable)
          : "false",
    },

    validationSchema: StatesValidationSchema.UniversitySchema,
    enableReinitialize: true,

    onSubmit: async (values, { resetForm, setSubmitting }) => {
      console.log(universityEdit?.id);
      try {
        setSubmitting(true);
        let response;
        // If it's Edit data it will call Update api
        if (universityEdit?.id) {
          response = await api.put(
            `/api/universities/${universityEdit?.id}`,
            values,
          );
          console.log(values);
        }

        // Else it's Add data it will call Add api
        else {
          console.log(values);

          response = await api.post("/api/universities", values);
        }
        // Show success toast
        toast.success(
          `University ${universityEdit?.id ? "updated" : "added"} successfully!`,
          {
            position: "top-right",
            autoClose: 2000,
          },
        );
        onSuccess(response.data.data);
        resetForm();
        onClose();
      } catch (error) {
        toast.error("Failed to submit. Please try again.", {
          autoClose: 3000,
        });
        console.error("API Error:", error);
      } finally {
        setSubmitting(false);
      }
    },
  });
  // Univerisities image upload in FTP
  const fileInputRef = useRef(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [loadingImage, setLoadingImage] = useState(false);
  const [universitytype, setUniversitytype] = useState("upload");
  const [imagesUrl, setImagesUrl] = useState([]);
  const [deletingImage, setDeletingImage] = useState(false);

  const handleIconClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      setImageError("");
      console.log("File selected:", file.name);
    }
  };
  const handleUploadClick = async () => {
    if (!selectedFile) {
      console.log("No file selected!");
      return;
    }
    setLoadingImage(true);
    const formData = new FormData();
    formData.append("file", selectedFile);

    try {
      const response = await api.post(
        "/api/ftp/uploadUniversityImage",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        },
      );
      setUniversityImage(response.data.path);
      formik.setFieldValue("image", response.data.path);
      console.log("Upload success:", response.data);
      setLoadingImage(false);
    } catch (error) {
      if (error.response) {
        if (error.response.status === 409) {
          setImageError(error.response.data.errorMessage);
          setLoadingImage(false);
        }
        console.error("Server responded with error:", error.response.data);
      } else if (error.request) {
        console.error("No response received:", error.request);
      } else {
        console.error("Error setting up request:", error.message);
      }
    }
  };
  // Delete upload image record api fetch data
  const handleDelete = async () => {
    setDeletingImage(true);
    setLoadingImage(false);
    setImageError(false);
    try {
      await api.put(`/api/ftp/delete`, { path: universityImage });
      setUniversityImage("");
      setDeletingImage(false);
      formik.setFieldValue("image", "");
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    } catch (error) {
      console.error("Delete failed:", error);
      if (error.response.status === 400) {
        setImageError(error.response.data.errorMessage);
      }
    } finally {
      setDeletingImage(false);
    }
  };
  // Get iamge url api
  useEffect(() => {
    api
      .get("/api/ftp/getUniversities")
      .then((response) => {
        setImagesUrl(response.data.files);
      })
      .catch((error) => {
        console.log("Error fecthing get api", error);
      })
      .finally(() => setLoadingImage(false));
  }, []);
  // Updating Universitytype state
  useEffect(() => {
    if (universityEdit && Object.keys(universityEdit).length > 0) {
      setUniversitytype("select");
    } else {
      setUniversitytype("upload");
    }
  }, [universityEdit]);
  return (
    <>
      {/* Loading State */}
      {isLoading && (
        <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
          <CircularProgress />
        </Box>
      )}
      <Modal open={open} onClose={onClose} disableScrollLock>
        <Box
          sx={{ ...MODAL_STYLES.standard, width: { xs: 340, md: 500 } }}
          component="form"
          onSubmit={formik.handleSubmit}
        >
          <Typography
            variant="h5"
            component="h2"
            sx={{ mb: 3, fontWeight: 600 }}
          >
            {universityEdit && Object.keys(universityEdit).length > 0
              ? "Update University"
              : "Add University"}
          </Typography>
          <Box sx={FORM_STYLES.container}>
            <TextField
              label="University Name"
              name="name"
              value={formik.values.name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.name && Boolean(formik.errors.name)}
              helperText={formik.touched.name && formik.errors.name}
              {...TEXT_FIELD_STYLES.standard}
            />
            <TextField
              label="University Code"
              name="code"
              value={formik.values.code}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.code && Boolean(formik.errors.code)}
              helperText={formik.touched.code && formik.errors.code}
              {...TEXT_FIELD_STYLES.standard}
            />
            <FormControl>
              <FormLabel
                component="legend"
                sx={{ color: "#66667f !important", fontWeight: 450 }}
              >
                Select University Image Type
              </FormLabel>

              <RadioGroup
                row
                aria-labelledby="demo-form-control-label-placement"
                name="position"
                value={universitytype}
                onChange={(e) => setUniversitytype(e.target.value)}
              >
                <FormControlLabel
                  value="upload"
                  control={<Radio />}
                  label="Upload Image"
                />
                <FormControlLabel
                  value="select"
                  control={<Radio />}
                  label="Select Image"
                />
              </RadioGroup>
            </FormControl>
            {universitytype == "upload" ? (
              <>
                <Box sx={{ display: "flex", gap: 1, marginTop: "10px" }}>
                  <TextField
                    fullWidth
                    size="small"
                    type="file"
                    name="image"
                    inputRef={fileInputRef}
                    inputProps={{ accept: "image/*" }}
                    onChange={handleFileChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.image && Boolean(formik.errors.image)}
                  />

                  <Tooltip title="Upload image" arrow placement="top">
                    <IconButton
                      color="primary"
                      onClick={handleUploadClick}
                      size="small"
                      sx={{}}
                    >
                      <UploadFileIcon style={{ cursor: "pointer" }} />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Delete image" arrow placement="top">
                    <IconButton
                      color="error"
                      onClick={() => handleDelete()}
                      size="small"
                      sx={{}}
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Box>
                {/* SHOW NOTE ONLY WHEN NO MESSAGES ARE ACTIVE */}
                {!loadingImage &&
                  !deletingImage &&
                  !imageError &&
                  !universityImage && (
                    <Typography
                      sx={{
                        color: "#66667f",
                        fontSize: "13px",
                        fontStyle: "italic",
                      }}
                    >
                      Note: After clicking the upload button, wait until the
                      image URL appears.
                    </Typography>
                  )}

                {/* ERROR OR STATUS MESSAGES */}
                {imageError ? (
                  <Typography
                    sx={{
                      color: "red",
                      fontSize: "14px",
                    }}
                  >
                    {imageError}
                  </Typography>
                ) : (
                  <Typography
                    sx={{
                      color: "#66667f",
                      fontSize: "13px",
                      fontStyle: "italic",
                    }}
                  >
                    {loadingImage && " ...Uploading Image"}
                    {deletingImage && " ...Deleting Image"}
                    {!loadingImage && !deletingImage && universityImage && (
                      <>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Typography sx={{ fontSize: "13px", color: "#666" }}>
                            Image Url: {universityImage}
                          </Typography>

                          <Box
                            component="img"
                            src={`https://siaedutech.com/public/${universityImage}`}
                            alt="preview"
                            sx={{
                              width: "70px",
                              borderRadius: 1,
                              border: "1px solid #ddd",
                              ml: 1,
                            }}
                          />
                        </Box>
                      </>
                    )}
                  </Typography>
                )}
              </>
            ) : (
              <FormControl
                size="small"
                fullWidth
                error={formik.touched.active && Boolean(formik.errors.active)}
                sx={{ mt: 2 }}
              >
                <InputLabel>Image URL</InputLabel>
                <Select
                  label="Image URL"
                  labelId="image-select-label"
                  id="image"
                  name="image"
                  value={formik.values.image}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.image && Boolean(formik.errors.image)}
                  helperText={formik.touched.image && formik.errors.image}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: "400px",
                        overflowY: "auto",
                      },
                    },
                  }}
                  sx={{
                    "& .MuiSelect-select": {
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    },
                  }}
                >
                  {imagesUrl.map((img, index) => (
                    <MenuItem
                      value={img}
                      key={index}
                      sx={{
                        "& .MuiSelect-select": {
                          display: "flex",
                          alignItems: "center",
                          gap: 2,
                        },
                      }}
                    >
                      <Box
                        component="img"
                        src={`https://siaedutech.com/public/${img}`}
                        alt="preview"
                        sx={{
                          width: "100px",
                          borderRadius: 1,
                          border: "1px solid #ddd",
                        }}
                      />{" "}
                      <Typography
                        sx={{
                          fontSize: "14px",
                          color: "#555",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {img}
                      </Typography>
                    </MenuItem>
                  ))}
                </Select>

                {formik.touched.image && formik.errors.image && (
                  <FormHelperText sx={{ color: "red" }}>
                    {formik.errors.image}
                  </FormHelperText>
                )}
              </FormControl>
            )}
            <TextField
              label="Image Url"
              name="image"
              value={formik.values.image}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.image && Boolean(formik.errors.image)}
              helperText={formik.touched.image && formik.errors.image}
              {...TEXT_FIELD_STYLES.standard}
            />
            <TextField
              label="thumbnail Url"
              name="thumbnail"
              value={formik.values.thumbnail}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.thumbnail && Boolean(formik.errors.thumbnail)
              }
              helperText={formik.touched.thumbnail && formik.errors.thumbnail}
              {...TEXT_FIELD_STYLES.standard}
            />
            <FormControl
              fullWidth
              error={formik.touched.stateId && Boolean(formik.errors.stateId)}
            >
              <InputLabel>State</InputLabel>
              <Select
                name="stateId"
                value={formik.values.stateId}
                onChange={formik.handleChange}
                label="State"
                onBlur={formik.handleBlur}
                error={formik.touched.stateId && Boolean(formik.errors.stateId)}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: 400,
                    },
                  },
                }}
              >
                {states.map((u) => (
                  <MenuItem key={u.id} value={u.id}>
                    {u.name}
                  </MenuItem>
                ))}
              </Select>
              {formik.touched.stateId && formik.errors.stateId && (
                <FormHelperText sx={{ color: "red" }}>
                  {formik.errors.stateId}
                </FormHelperText>
              )}
            </FormControl>
            <FormControl
              fullWidth
              error={formik.touched.active && Boolean(formik.errors.active)}
              sx={{ mt: 2 }}
            >
              <InputLabel id="active-label">Active</InputLabel>
              <Select
                labelId="active-label"
                id="active"
                name="active"
                value={formik.values.active}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                label="Active"
              >
                <MenuItem value="true">Yes</MenuItem>
                <MenuItem value="false">No</MenuItem>
              </Select>
              {formik.touched.active && formik.errors.active && (
                <FormHelperText>{formik.errors.active}</FormHelperText>
              )}
            </FormControl>
            <FormControl
              fullWidth
              error={formik.touched.active && Boolean(formik.errors.active)}
              sx={{ mt: 2 }}
            >
              <InputLabel id="active-label">Viewable</InputLabel>
              <Select
                labelId="active-label"
                id="viewable"
                name="viewable"
                value={formik.values.viewable}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                label="viewable"
              >
                <MenuItem value="true">Yes</MenuItem>
                <MenuItem value="false">No</MenuItem>
              </Select>
              {formik.touched.viewable && formik.errors.viewable && (
                <FormHelperText>{formik.errors.viewable}</FormHelperText>
              )}
            </FormControl>

            <Box
              sx={FORM_STYLES.actions}
              style={{
                display: "flex",
                marginTop: "20px",
                justifyContent: "flex-end",
                gap: "10px",
              }}
            >
              <Button onClick={onClose} {...BUTTON_STYLES.secondary}>
                Cancel
              </Button>
              <Button
                type="submit"
                disabled={formik.isSubmitting}
                {...BUTTON_STYLES.primary}
              >
                {formik.isSubmitting ? "Processing..." : "Save"}
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  );
}

export default UniversityModal;
